// import isEmpty  from 'lodash/isEmpty';

let compName = 'todos' 

const initialState = {
    todos: [],
}

export default (state = initialState, action = {}) => {
    
    switch (action.type) {
        // This action is used anytime you modify list when ever you drag a row,
        // delete item, or add an item to the item list.
        case 'UPDATE_TODOS_LIST':  /* called when PicListsPage component mounts */
            return {
                list: action.list
            }
        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./src/reducers/todos.js